const Mln = {
  symbol: 'mln',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" fill-rule="evenodd" d="M8.627 20.124l1.36-.786-.178-.309-1.342.775v-7.851l6.82 4.042v11.56L16 28l.714-.445v-11.56l6.819-4.042v7.852l-1.343-.776-.178.31 1.36.785-5.27 3.092v1.729L25 20.885v-10.59L16 5l-9 5.295v10.59l6.899 4.06v-1.73l-5.272-3.091zm7.175-13.31v1.581h.357V6.791l6.66 3.908L16 14.742l-6.82-4.043 6.622-3.885zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-.198-22.594v1.657h.357V9.406h-.357zm0 2.668v1.657l.178.081.179-.08v-1.658h-.357zm5.56 6.45l-1.435-.829-.179.31 1.436.828.178-.309zm-2.265-1.334l-1.436-.828-.159.114-.02.195 1.436.828.179-.309zm-8.46 1.334l.179.31 1.435-.83-.179-.309-1.435.83zm2.266-1.334l.178.31 1.435-.83-.019-.194-.159-.114-1.435.828z"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" r="16" fill="#0B1529"/><path fill="#FFF" d="M8.627 20.124l5.272 3.092v1.729L7 20.885v-10.59L16 5l9 5.295v10.59l-6.899 4.06v-1.73l5.271-3.091-1.36-.786.178-.309 1.343.776v-7.852l-6.82 4.042v11.56L16 28l-.714-.445v-11.56l-6.819-4.042v7.851l1.342-.775.178.31-1.36.785zm7.175-13.31L9.18 10.699 16 14.742l6.82-4.043-6.661-3.908v1.604h-.357V6.814zm0 2.592h.357v1.657h-.357V9.406zm0 2.668h.357v1.657l-.179.081-.178-.08v-1.658zm5.56 6.45l-.178.31-1.436-.83.179-.309 1.435.83zm-2.265-1.334l-.179.31-1.435-.83.02-.194.158-.114 1.436.828zm-8.46 1.334l1.435-.829.179.31-1.435.828-.179-.309zm2.266-1.334l1.435-.828.16.114.018.195-1.435.828-.178-.309z"/></g>`;
  }
};
export default Mln;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/mln.js
// module id = null
// module chunks = 